// extracted by mini-css-extract-plugin
export var boldText = "_5j-4";
export var checkboxContainer = "_5j-6";
export var closeIcon = "_5j-i";
export var container = "_5j-0";
export var drawer = "_5j-8";
export var drawerContent = "_5j-9";
export var extraSmallText = "_5j-5";
export var fulfillmentGroupTable = "_5j-e";
export var largeText = "_5j-3";
export var loadingSpinnerContainer = "_5j-j";
export var mediumText = "_5j-2";
export var narrow = "_5j-f";
export var notificationLink = "_5j-l";
export var packageCheckIconContainer = "_5j-7";
export var slideoutHeaderActions = "_5j-g";
export var slideoutHeaderActionsShifted = "_5j-h";
export var slideoutHeaderContainer = "_5j-a";
export var slideoutModal = "_5j-c";
export var stickyHeaderWrapper = "_5j-b";
export var table = "_5j-k";
export var tableContainer = "_5j-d";
export var tertiaryText = "_5j-1";